import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import { SwitchExpertForm, FluentSwitchExpertForm } from './switch-expert-form';

const modalStyle = {
  overlay: {
    zIndex: 2000,
    backgroundColor: 'rgba(51,51,51,0.5)',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    border: '1px solid #d9d9d9',
    borderRadius: '0px',
    transform: 'translate(-50%, -50%)',
    marginRight: '-50%',
  },
};

const SwitchExpertModal = (props) => {
  const Form = props.isFluentNewUI ? FluentSwitchExpertForm : SwitchExpertForm;
  return (
    <Modal
      isOpen={props.isOpen}
      style={modalStyle}
      ariaHideApp={false}
    >
      <Form
        shouldReload={props.shouldReload}
        isFluentNewUI={props.isFluentNewUI}
        i18n={props.i18n}
        onSuccess={props.onSuccess}
        onCancel={props.onClose}
        context={props.context}
      />
    </Modal>
  );
};

SwitchExpertModal.defaultProps = {
  isOpen: false,
  isFluentNewUI: false,
  shouldReload: false,
};

SwitchExpertModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
    getCldr: PropTypes.func,
  }).isRequired,
  context: PropTypes.shape({
    accountId: PropTypes.number,
    customerId: PropTypes.number,
    userId: PropTypes.number,
  }).isRequired,
  isFluentNewUI: PropTypes.bool,
  shouldReload: PropTypes.bool,
};

export { SwitchExpertModal };
